import { useEffect, useState } from 'react';

/**
 * True from `breakpoint` px and up. Mirrors the sidebar's `min-[1600px]:`
 * Tailwind variant so the layout grid reserves the wider rail on large screens.
 */
export function useIsWideScreen(breakpoint = 1600) {
  const [isWide, setIsWide] = useState(() =>
    typeof window !== 'undefined' ? window.innerWidth >= breakpoint : false,
  );

  useEffect(() => {
    const mq = window.matchMedia(`(min-width: ${breakpoint}px)`);
    const handler = (e: MediaQueryListEvent) => setIsWide(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, [breakpoint]);

  return isWide;
}
